function toCssVar(param: string): string {
  return '--theme-' + param.replace(/[A-Z]/g, letter => `-${letter.toLowerCase()}`);
}

export function applyTheme(params: URLSearchParams) {
  const root = document.documentElement;

  // Apply theme preset first (dark/light)
  const theme = params.get('theme');
  if (theme) {
    root.dataset.theme = theme;
  }

  // Apply individual color overrides
  for (const [param, value] of params) {
    if (param === 'theme') continue;
    const colorValue = value.startsWith('#') || value.startsWith('rgba') ? value : `#${value}`;
    root.style.setProperty(toCssVar(param), colorValue);
  }

  // Enable logo theming only when logo param is provided
  if (params.has('logo')) {
    root.dataset.logoThemed = '';
  }
}
